module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 104.2dcf1ba4.png";